import { render, staticRenderFns } from "./ProjectListBody.vue?vue&type=template&id=4a8528c9&scoped=true&"
import script from "./ProjectListBody.vue?vue&type=script&lang=js&"
export * from "./ProjectListBody.vue?vue&type=script&lang=js&"
import style0 from "./ProjectListBody.vue?vue&type=style&index=0&id=4a8528c9&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8528c9",
  null
  
)

export default component.exports